/** Bump when legal text changes so users must re-accept. */
export const PUBLISH_CONTENT_TERMS_VERSION = '1.0';

export function getPublishContentTerms(): string {
    return $localize`StoryHunt Content Responsibility Terms

These terms apply when you publish a tour (or publish changes to a tour) on the StoryHunt Platform.

1. You are the publisher
1.1 You alone are responsible for all content you publish, including text, images, audio, video, maps, names, brands, logos, and any other material in your tours and stories ("Your Content").
1.2 StoryHunt ApS ("StoryHunt") provides the platform tools. StoryHunt does not create, endorse, or take responsibility for Your Content.

2. Rights and legality
2.1 By publishing, you confirm that you own Your Content or have all rights, licenses, and permissions needed to publish and distribute it on the StoryHunt Platform.
2.2 You confirm that Your Content does not infringe copyright, trademark, privacy, publicity, or other rights, and does not otherwise violate applicable law.
2.3 You are solely responsible for copyright and other intellectual property compliance in Your Content, including any third-party material you include.

3. No StoryHunt liability for Your Content
3.1 To the maximum extent permitted by law, StoryHunt is not liable for Your Content or for any claim, loss, or damage arising from it, including copyright claims, takedown requests, or disputes with third parties.
3.2 StoryHunt does not undertake to review Your Content before publication and is not obliged to monitor user content, similar to other online platforms that host user-generated content.
3.3 StoryHunt may remove, unpublish, or restrict access to Your Content if we believe it may infringe rights, violate law, or breach these terms or our policies.

4. Indemnity
4.1 You agree to indemnify and hold StoryHunt harmless from claims, costs, and damages (including reasonable legal fees) arising from Your Content or your breach of these terms.

5. Account and authority
5.1 By accepting these terms, you confirm that you are authorized to bind the account, organization, or company under which you publish.
5.2 Acceptance is recorded with your user identity, username, email, and timestamp, and applies to future publishing under that account.

6. Governing law
6.1 These terms are governed by Danish law. The City Court of Copenhagen has jurisdiction in the first instance, unless mandatory law provides otherwise.

Version: ${PUBLISH_CONTENT_TERMS_VERSION}`;
}
